import { BriefingModelVersion, CreateAppointmentRecordInput } from "~/api/API";

/**
 * Stamps `briefingModelVersion=V2` on a CreateAppointmentRecord input.
 * V2 is the only supported briefing model — every new appointment is V2,
 * regardless of brand-new vs inherit (reschedule, re-eval, supplemental,
 * deposition, deposition hold).
 */
export function applyV2BriefingVersion(
  input: CreateAppointmentRecordInput,
): CreateAppointmentRecordInput {
  return { ...input, briefingModelVersion: BriefingModelVersion.V2 };
}
